import _extends from "@babel/runtime/helpers/esm/extends";
var _IconAdd;
import React from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Button, Container, IconAdd, Skeleton, Stack, Typography } from '@lumahealthhq/ui-core';
import { usePermissions } from '@lumahealthhq/ui-model';
import { EProvisioning } from '@lumahealthhq/ui-model-types';

/**
 * This is the Fallback component to render till the module is ready.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FallbackContainerSchedulerCalendar(props) {
  var intl = useIntl();
  var _usePermissions = usePermissions(),
    hasAccessToProduct = _usePermissions.hasAccessToProduct;
  var hasAccessToSchedulerAssist = hasAccessToProduct(EProvisioning.SchedulerAssist);
  return /*#__PURE__*/_jsx(Container, _extends({
    maxWidth: false,
    disableGutters: true
  }, props, {
    children: /*#__PURE__*/_jsxs(Stack, {
      gap: 4,
      height: "100%",
      children: [/*#__PURE__*/_jsxs(Stack, {
        justifyContent: "space-between",
        direction: "row",
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h3",
          children: intl.formatMessage({
            id: "hGQqkW",
            defaultMessage: [{
              "type": 0,
              "value": "Schedule"
            }]
          })
        }), hasAccessToSchedulerAssist && /*#__PURE__*/_jsx(Button, {
          disabled: true,
          startIcon: _IconAdd || (_IconAdd = /*#__PURE__*/_jsx(IconAdd, {})),
          variant: "primary",
          size: "large",
          children: intl.formatMessage({
            id: "lUV0hp",
            defaultMessage: [{
              "type": 0,
              "value": "Schedule Appointment"
            }]
          })
        })]
      }), /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        gap: 2,
        height: "100%",
        overflow: "hidden",
        children: [/*#__PURE__*/_jsx(Skeleton, {
          width: "292px",
          height: "100%",
          sx: {
            transform: 'none'
          }
        }), /*#__PURE__*/_jsx(Skeleton, {
          width: "100%",
          height: "100%",
          sx: {
            transform: 'none'
          }
        })]
      })]
    })
  }));
}